import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router'

// Components
import { App } from '../../../App';
import { getLibrary } from '../Library/redux/library.actions';
import { getAlbum } from '../Album/redux/album.actions';
import { FullAlbums } from '../Album/redux/album.selectors';
import { searchAssets } from './redux/assets.actions';
import { FullAssets } from './redux/assets.selectors';
import { FullLibraries } from '../Library/redux/library.selectors';
import { useParams } from 'react-router-dom';
import { TERM_ALBUM_PLURAL, hasAccess, useActiveItem } from '../../services/CaptureCollabService';
import { SmartContainer } from '../../../styles/Containers';
import { StyledButton } from '../../../styles/matieralui/Button';
import { LibraryNavigation } from '../Library/LibraryNavigation';
import { AssetsList } from './AssetsList';
import { FullScreenLoader } from '../../../components/Loaders/FullScreenLoader';
import { FullGenericTags } from '../GenericTags/redux/generictags.selectors';
import { searchGenericTags } from '../GenericTags/redux/generictags.actions';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { IconSettings } from '../../Icons';
import { StyledModal } from '../../../styles/matieralui/Modal';
import { AssetViewer } from './AssetViewer';
import { StyledFullScreenModal } from '../../components/Content/FullScreenModal';
import { Role } from '../../../redux/Auth/auth.selectors';
import { useMyPermissions } from '../Permission/redux/permissions.actions';
import { NoPermissions } from '../Permission/NoPermissions';
import { RouteBreadCrumbs } from '../../../routes';
import { TopLevelNavigation } from '../../components/Dashboard/TopLevelNavigation';


// Redux


export const PageAssets = () => {

    // New Modal
    const dispatch = useDispatch();
    const storeLibraries = FullLibraries();
    const storeAlbums = FullAlbums();
    const storeTags = FullGenericTags();
    const { id, albumId } = useParams();
    const [openViewer, setOpenViewer] = useState(false);
    const [activeAsset, setActiveAsset] = useState(null);
    const currentUserRole = Role();
    const { permissions, hasPermission, getPermissionRole, permissionChecked } = useMyPermissions();
    const [noAccess, setNoAccess] = useState(false);
    const [myRole, setMyRole] = useState(null);

    // Library
    const { activeItem: activeLibrary } = useActiveItem({ id, model: 'Libary', selector: FullLibraries, getAction: getLibrary })
    // Album
    const { activeItem: activeAlbum } = useActiveItem({ id: albumId, model: 'ALbum', selector: FullAlbums, getAction: getAlbum })

    // --------------------------
    // Effects
    // --------------------------
    // Get This Item
    // useEffect(() => {
    //     // dispatch(getLibrary(id));
    //     // dispatch(getAlbum(albumId));
    //     // dispatch(searchGenericTags(0, null, null, 'all'))
    // }, [id, albumId]);


    // Check Permissions
    useEffect(() => {

        if (hasPermission('Library', id)) {
            const r = getPermissionRole('Library', id);
            setNoAccess(false);
            setMyRole(r);
        } else {

            setNoAccess(true);
        }

    }, [permissions])


    // --------------------------
    // Interactions
    // --------------------------

    // On Select
    const handleSelect = (item) => {
        // setActiveAsset(item);
        // setOpenViewer(true);
        dispatch(push(`/asset/${item.id}`))
    }

    // --------------------------
    // Renders
    // --------------------------
    const renderTopBarChildren = () => {

        if (noAccess) return null;

        return (
            <SmartContainer flex align="center" justify="flex-end">
                {id && albumId && (myRole === 'owner' || myRole === 'admin') && (<StyledIconButton onClick={() => dispatch(push(`/library/${id}/album/${albumId}/settings`))}><IconSettings /></StyledIconButton>)}
                {myRole !== 'viewer' && (<StyledButton variant='contained' color='blue' onClick={() => dispatch(push(`/library/${id}/album/${albumId}/upload`))}>Upload</StyledButton>)}
            </SmartContainer>
        )

    }

    const renderPageNavigation = () => {
        return (<TopLevelNavigation />)
        // return (<LibraryNavigation libraryId={id} />)
    }



    // Render Page

    if (!activeLibrary?.id && !activeAlbum?.id) return (<FullScreenLoader />)

    const filters = {
        Library: `["${activeLibrary?.id}"]`,
        Album: `["${activeAlbum?.id}"]`
    }

    const title = (id && albumId && activeAlbum && activeLibrary) ? `${activeLibrary?.name} > ${activeAlbum?.name}` : "Loading...";

    return (
        <App title={title}
            pageNavigation={renderPageNavigation}
            topBarChildren={renderTopBarChildren()}
            breadcrumbs={[RouteBreadCrumbs.libraries, { href: `/library/${id}/albums`, title: TERM_ALBUM_PLURAL }, { href: `/library/${id}`, title: 'Recent' }]}
        >
            {(noAccess || permissionChecked === 'notchecked') && (<NoPermissions checked={permissionChecked} />)}
            {(!noAccess && permissionChecked !== 'notchecked') && activeLibrary && activeAlbum && (
                <AssetsList onSelect={handleSelect} filters={filters} myRole={myRole} sortByKey={`${albumId}SortAssets`} filterByDateKey={`${albumId}FilterDateAssets`} filterByTypeKey={`${albumId}FilterTypeAssets`} />
            )}
            <StyledFullScreenModal open={openViewer} onClose={() => setOpenViewer(false)} fullWidth>
                <AssetViewer onClose={() => setOpenViewer(false)} asset={activeAsset} myRole={myRole} />
            </StyledFullScreenModal>
        </App>
    )
}